firebird.factory('virtualBackgroundService', [
    '$rootScope',
    '$window',
    'brandingService',
    'helperService',
    'localizationService',
    'logService',
    'storageService',
    'avDeviceService',
    'meetingService',
    'analyticsWrapperService',
    function (
        $rootScope,
        $window,
        brandingService,
        helperService,
        localizationService,
        logService,
        storageService,
        avDeviceService,
        meetingService,
        analyticsWrapperService
    ) {
        const logger = logService.createLoggerWithSource('virtualBackgroundService');

        var service = {
            deleteCustomVirtualBackground: deleteCustomVirtualBackground,
            uploadCustomVirtualBackground: uploadCustomVirtualBackground,
            showPreview: showPreview,
            openFileUploadDialog: openFileUploadDialog,
            hasPreview: hasPreview,
            getUploadTooltip: getUploadTooltip,
            requestFilteredBackgroundStream: requestFilteredBackgroundStream,
            stopFilteredBackgroundStream: stopFilteredBackgroundStream,
            hasVirtualBackground: hasVirtualBackground,
            getVirtualBackground: getVirtualBackground,
            updateFilter: updateFilter,
            getPreviewFilter: getPreviewFilter,
            resetError: resetError,
            init: init
        };

        var filterTemplate = {
            name: null,
            value: null,

            canvasInput: null,
            canvasOutput: null,
            canvasMask: null,
            canvasBg: null,
            videoStream: null,
            interval: null,
            videoInput: null,
            canvasStream: null,
            background: null
        };

        var previewFilters = {};

        var customVirtualBackgroundFileUploadInput = '#custom-virtual-background-file-upload';
        var customVirtualBackgroundTile = '.background-cell.add-background';
        var customVirtualBackgroundStorageKey = 'customVirtualBackground';

        // Is .mp4 video allowed as a customer virtual background
        var isMp4Allowed = false;

        var currentPreview;

        var maximumImageFileSizeInMB = 4000000; // bytes. Same as 4 Megabytes (MB)

        var uploadError = '';

        init();

        return service;

        ////////////////////////

        function requestFilteredBackgroundStream(filter, identifier) {
            if (!meetingService.getVirtualBackgroundEnabled()) {
                return;
            }
            if (!avDeviceService.hasCamera() || !avDeviceService.getDevicePermissions().videoAllowed) {
                return;
            }
            var mergedFilter = previewFilters[identifier];
            if (!mergedFilter) {
                mergedFilter = {};
                Object.assign(mergedFilter, filterTemplate);
            }

            Object.assign(mergedFilter, filter);
            mergedFilter.name = identifier;
            previewFilters[identifier] = mergedFilter;
            $rootScope.$broadcast('start-virtual-background-stream', { filter: mergedFilter, identifier: identifier });
        }

        function stopFilteredBackgroundStream(identifier) {
            if (!meetingService.getVirtualBackgroundEnabled()) {
                return;
            }
            if (!avDeviceService.hasCamera() || !avDeviceService.getDevicePermissions().videoAllowed) {
                return;
            }
            if (!previewFilters[identifier]) {
                return;
            }
            $rootScope.$broadcast('stop-virtual-background-stream', {
                filter: previewFilters[identifier],
                identifier: identifier
            });
        }

        function hasVirtualBackground() {
            return !!storageService.get('videoFilter');
        }

        function getVirtualBackground() {
            return storageService.get('videoFilter');
        }

        function updateFilter(filter, identifier) {
            var updatedFilter = previewFilters[identifier];
            if (!updatedFilter) {
                return;
            }

            updatedFilter = Object.assign(updatedFilter, filter);
            previewFilters[identifier] = updatedFilter;
        }

        function init() {
            currentPreview = storageService.get('customVirtualBackground');
        }

        function showPreview(overrideCurrentPreview) {
            if (overrideCurrentPreview) {
                currentPreview = overrideCurrentPreview;
            }

            if (currentPreview !== null && currentPreview !== undefined) {
                $window.$(customVirtualBackgroundTile).css('background-image', "url('" + currentPreview + "')");
                $window.$(customVirtualBackgroundTile).addClass('preview');
            }
        }

        function hasPreview() {
            return currentPreview !== null && currentPreview !== undefined;
        }

        function getUploadTooltip() {
            if (uploadError) {
                return uploadError;
            }
            if (service.hasPreview()) {
                return '';
            } else {
                var fileTypes = 'png, jpg';

                if (isMp4Allowed) {
                    fileTypes += ',mp4';
                }

                return fileTypes;
            }
        }

        function openFileUploadDialog() {
            if (service.hasPreview() === false) {
                $rootScope.$broadcast('virtual-background-show-upload-dialog');
            }
        }

        function uploadCustomVirtualBackground() {
            var file = $window.$(customVirtualBackgroundFileUploadInput)[0].files[0];

            if (file) {
                if (isMp4Allowed === true && file.type === 'video/mp4') {
                } else if (file.type && (file.type.startsWith('image/png') || file.type.startsWith('image/jpeg'))) {
                    // Check to make sure the image is not larger than the maximum image file size
                    if (file.size > maximumImageFileSizeInMB) {
                        $window.$(customVirtualBackgroundFileUploadInput).val('');

                        uploadError = localizationService.translate(
                            'HEADER.SETTINGS.VIRTUAL_BACKGROUND.MAX_SIZE_WARNING'
                        );
                        $rootScope.$broadcast('virtual-background-custom-upload-error');
                        logger.error(
                            'uploadCustomVirtualBackground',
                            'customVirtualBackground file size over max allowed size',
                            file.size
                        );
                        return;
                    }

                    var image = new $window.Image();

                    image.onload = function (event) {
                        var w = image.naturalWidth || image.width;
                        var h = image.naturalHeight || image.height;

                        var canvas = $window.document.createElement('canvas');
                        canvas.width = 640;
                        canvas.height = 360;

                        var cw = canvas.width;
                        var ch = canvas.height;
                        if (w && h) {
                            // preserve the aspect ratio
                            if (w / h >= cw / ch) {
                                cw = canvas.width = (ch * w) / h; // increase canvas width, keep height same
                            } else {
                                ch = canvas.height = (cw * h) / w; // increase canvas height, keep width same.
                            }
                        }

                        canvas.getContext('2d').drawImage(image, 0, 0, w, h, 0, 0, cw, ch);

                        currentPreview = canvas.toDataURL('image/jpeg');

                        storageService.set('customVirtualBackground', currentPreview);

                        service.showPreview();

                        URL.revokeObjectURL(image.src);

                        analyticsWrapperService.eventTrack(
                            'Meeting - Successfully uploaded Custom Virtual Background',
                            {
                                category: 'Virtual Background Settings'
                            }
                        );

                        broadcastUpdate();
                    };

                    image.onerror = function (e) {
                        uploadError = localizationService.translate(
                            'HEADER.SETTINGS.VIRTUAL_BACKGROUND.UNSUPPORTED_WARNING'
                        );
                        $rootScope.$broadcast('virtual-background-custom-upload-error');
                        logger.error('uploadCustomVirtualBackground: image.onerror', 'customVirtualBackground src', e);
                    };

                    image.src = $window.URL.createObjectURL(file);
                } else {
                    uploadError = localizationService.translate(
                        'HEADER.SETTINGS.VIRTUAL_BACKGROUND.UNSUPPORTED_WARNING'
                    );
                    $rootScope.$broadcast('virtual-background-custom-upload-error');
                    logger.error('uploadCustomVirtualBackground', 'customVirtualBackground wrong file type', file.type);
                }

                // Reset the input value
                $window.$(customVirtualBackgroundFileUploadInput).val('');
            }
        }

        function deleteCustomVirtualBackground() {
            // Unset the file upload input
            $window.$(customVirtualBackgroundFileUploadInput).val('');

            $window.$(customVirtualBackgroundTile).css('background-image', 'none');
            $window.$(customVirtualBackgroundTile).removeClass('preview');

            currentPreview = undefined;

            // Delete CVB
            storageService.remove('customVirtualBackground');

            broadcastUpdate();
        }

        function broadcastUpdate() {
            $rootScope.$broadcast('custom-vb-updated');
        }

        function getPreviewFilter(identifier) {
            return previewFilters[identifier];
        }

        function resetError() {
            uploadError = '';
        }
    }
]);
